if (!customElements.get('rj-product-assistance')) {
  customElements.define('rj-product-assistance', class extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.addEventListener('click', event => {
          if (event.target.closest('a[data-product-inquiry], a[data-product-bespoke]')) this.updateInquiry();
        });
      }
      this.updateInquiry();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const info = this.closest('product-info');
          if (String(event.data.sectionId) === String(info?.dataset.section)) {
            this.updateInquiry(event.data.variant);
          }
        });
      }
    }
    disconnectedCallback() {
      this.unsubscribeVariant?.();
      this.unsubscribeVariant = null;
    }
    updateInquiry(selectedVariant) {
      const link = this.querySelector('a[data-product-inquiry]');
      if (!link) return;
      const info = this.closest('product-info');
      const id = info?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      const variant = selectedVariant || variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', variant.title);
      link.href = url.toString();
      const bespoke = this.querySelector('a[data-product-bespoke]');
      if (bespoke) {
        const bespokeUrl = new URL(bespoke.href);
        bespokeUrl.searchParams.set('variant', variant.title);
        bespoke.href = bespokeUrl.toString();
      }
    }
  });
}
